import manager from '@micromag/intl';

var A7ncT3 = [{
  type: 0,
  value: "Déplaçable"
}];
var AA8TV9 = [{
  type: 0,
  value: "Image avec titre"
}];
var ACSasN = [{
  type: 0,
  value: "URL"
}];
var ACkeH6 = [{
  type: 0,
  value: "Quiz avec plusieurs questions"
}];
var AHvHaY = [{
  type: 0,
  value: "Paramètres"
}];
var AQ8Aig = [{
  type: 0,
  value: "Utilisé"
}];
var AV6gfh = [{
  type: 0,
  value: "Modifier l'action"
}];
var B5C18D = [{
  type: 0,
  value: "Badge"
}];
var BAfC6s = [{
  type: 0,
  value: "Ajouter un fichier de sous-titres"
}];
var BSTWf8 = [{
  type: 0,
  value: "Titre"
}];
var BgrRxZ = [{
  type: 0,
  value: "Intro"
}];
var BnRW4y = [{
  type: 0,
  value: "Titre des résultats"
}];
var BpZoQZ = [{
  type: 0,
  value: "Succès"
}];
var BwYZbB = [{
  type: 0,
  value: "Avec les contrôles"
}];
var CJmQeh = [{
  type: 0,
  value: "Image avec texte"
}];
var CWnXWp = [{
  type: 0,
  value: "Aucun bouton"
}];
var CrzYgw = [{
  type: 0,
  value: "Citation"
}];
var D21uVQ = [{
  type: 0,
  value: "Copier le lien"
}];
var D29KoV = [{
  type: 0,
  value: "align. gauche"
}];
var D7LIZQ = [{
  type: 0,
  value: "Démarrer"
}];
var D7kxD3 = [{
  type: 0,
  value: "Sans progression"
}];
var DU1qdc = [{
  type: 0,
  value: "Couleur du texte"
}];
var DWEzCv = [{
  type: 0,
  value: "Sélectionner une vidéo"
}];
var EDFyUp = [{
  type: 0,
  value: "Texte alternatif (accessibilité)"
}];
var EEUc6n = [{
  type: 0,
  value: "Lion"
}];
var EQdIAR = [{
  type: 0,
  value: "Description"
}];
var ET527E = [{
  type: 0,
  value: "Police"
}];
var EcZYpr = [{
  type: 0,
  value: "Sous-titre"
}];
var EoVdMy = [{
  type: 0,
  value: "Modifier le contenu"
}];
var Evl2dG = [{
  type: 0,
  value: "19 fév au 20 mars"
}];
var F0QDfY = [{
  type: 0,
  value: "23 sept au 22 oct"
}];
var F59wsl = [{
  type: 0,
  value: "Urbania Horoscope"
}];
var FKOWH0 = [{
  type: 0,
  value: "align. droite"
}];
var FOmgqv = [{
  type: 0,
  value: "Question"
}];
var FjuRaw = [{
  type: 0,
  value: "Paramètres du clavier"
}];
var G1Gyjn = [{
  type: 0,
  value: "Avancer"
}];
var GMCLhn = [{
  type: 0,
  value: "Case"
}];
var GPqjnH = [{
  type: 0,
  value: "Gauche"
}];
var GRVidW = [{
  type: 0,
  value: "Vidéo 360"
}];
var GzoKNb = [{
  type: 0,
  value: "Ligne du temps"
}];
var H1YcaV = [{
  type: 0,
  value: "Image avec légende"
}];
var HWpflq = [{
  type: 0,
  value: "Surbrillance"
}];
var HseFdk = [{
  type: 0,
  value: "Modifier"
}];
var HwqzVR = [{
  type: 0,
  value: "Visuel"
}];
var I1hyZY = [{
  type: 0,
  value: "Icône de réponse"
}];
var I2bIHm = [{
  type: 0,
  value: "Bonne réponse"
}];
var IBjY5r = [{
  type: 0,
  value: "Dupliquer l'écran"
}];
var ICXTfR = [{
  type: 0,
  value: "Liens"
}];
var J9e9Qb = [{
  type: 0,
  value: "Vidéo"
}];
var JAguka = [{
  type: 0,
  value: "Votre message"
}];
var JC9Qlf = [{
  type: 0,
  value: "Interlocuteurs"
}];
var JDPMlG = [{
  type: 0,
  value: "Couleur de l'arrière-plan"
}];
var JRZoe6 = [{
  type: 0,
  value: "Contenu"
}];
var JoWKee = [{
  type: 0,
  value: "Créez votre premier écran"
}];
var JoyIgA = [{
  type: 0,
  value: "Nb. minimum de points"
}];
var JzSBzL = [{
  type: 0,
  value: "Visuel"
}];
var K1BxIr = [{
  type: 0,
  value: "Modifier les métadonnées"
}];
var KB7N5E = [{
  type: 0,
  value: "Chercher un lieu sur Google Maps"
}];
var KCDOHI = [{
  type: 0,
  value: "Aucune police..."
}];
var KHWeV7 = [{
  type: 0,
  value: "Réponses"
}];
var KK5teQ = [{
  type: 0,
  value: "Ajouter un visuel"
}];
var KdAKt7 = [{
  type: 0,
  value: "Ajouter une image"
}];
var KuzZbb = [{
  type: 0,
  value: "Couleur de l'arrière-plan"
}];
var KvBdrU = [{
  type: 0,
  value: "Texte en arrière-plan"
}];
var LFziCV = [{
  type: 0,
  value: "Sans icône vrai/faux"
}];
var LI0Gz4 = [{
  type: 0,
  value: "Courriel"
}];
var LOknw0 = [{
  type: 0,
  value: "Styles"
}];
var LkVfwW = [{
  type: 0,
  value: "Écran "
}, {
  type: 1,
  value: "index"
}];
var Lrwi2G = [{
  type: 0,
  value: "Courriel"
}];
var MBgLeH = [{
  type: 0,
  value: "23 juil - 22 août"
}];
var MYZwSA = [{
  type: 0,
  value: "Audio"
}];
var MhGUaY = [{
  type: 0,
  value: "Diaporama"
}];
var MmJQ7o = [{
  type: 0,
  value: "Galerie avec légendes"
}];
var N25iDO = [{
  type: 0,
  value: "Titre"
}];
var N7Kj8z = [{
  type: 0,
  value: "Bouton"
}];
var NVUpOG = [{
  type: 0,
  value: "Ajuster la carte selon les marqueurs"
}];
var NmCfTO = [{
  type: 0,
  value: "Conversation"
}];
var NumcrW = [{
  type: 0,
  value: "Capricorne"
}];
var OSl7A6 = [{
  type: 0,
  value: "Swipe up"
}];
var OdcEna = [{
  type: 0,
  value: "Aucune diapo"
}];
var OkNUmk = [{
  type: 0,
  value: "Type"
}];
var Op1ZIp = [{
  type: 0,
  value: "21 jan au 18 fév"
}];
var P1dwGU = [{
  type: 0,
  value: "Titre avec sous-titre"
}];
var P9A8cx = [{
  type: 0,
  value: "align. milieu"
}];
var PFNMAQ = [{
  type: 0,
  value: "Bas"
}];
var PKCv5M = [{
  type: 0,
  value: "Aucun item"
}];
var PyxZY2 = [{
  type: 0,
  value: "Annuler"
}];
var QBaiO0 = [{
  type: 0,
  value: "Ajouter un écran"
}];
var QBlqW9 = [{
  type: 0,
  value: "Vidéos"
}];
var QSmRdP = [{
  type: 0,
  value: "Ajouter une image"
}];
var Qanvis = [{
  type: 0,
  value: "Visuel"
}];
var Qe03Xz = [{
  type: 0,
  value: "Sous-titre du signe"
}];
var QfpTKK = [{
  type: 0,
  value: "Sélectionnez un écran..."
}];
var QjbLZ9 = [{
  type: 0,
  value: "Vitesse de lecture (en Mots Par Minute)"
}];
var Qw8cb5 = [{
  type: 0,
  value: "Couleur du présentateur"
}];
var R9DB4a = [{
  type: 0,
  value: "Styles"
}];
var RHMS2f = [{
  type: 0,
  value: "Couleur de la ligne"
}];
var RcLsua = [{
  type: 0,
  value: "Message"
}];
var Rl7C1A = [{
  type: 0,
  value: "Couleur des contrôles"
}];
var RucIeL = [{
  type: 0,
  value: "Options de partage"
}];
var S9YpbV = [{
  type: 0,
  value: "Texte"
}];
var SyMSDa = [{
  type: 0,
  value: "Style du nom publié"
}];
var T0pi1u = [{
  type: 0,
  value: "Avec barre de défilement"
}];
var T9NZPQ = [{
  type: 0,
  value: "Images"
}];
var THKV4v = [{
  type: 0,
  value: "Longitude"
}];
var TZUu3s = [{
  type: 0,
  value: "Flou"
}];
var Tt4jN1 = [{
  type: 0,
  value: "Ajouter"
}];
var UBXIYP = [{
  type: 0,
  value: "Vidéo"
}];
var UG3SXh = [{
  type: 0,
  value: "Enlever"
}];
var UUv8FR = [{
  type: 0,
  value: "Nom"
}];
var UdrdRF = [{
  type: 0,
  value: "Style des numéros"
}];
var UlZIP8 = [{
  type: 0,
  value: "OK"
}];
var UtcYEP = [{
  type: 0,
  value: "Polices personnalisées"
}];
var VDu2FA = [{
  type: 0,
  value: "Google Fonts"
}];
var VMd1oG = [{
  type: 0,
  value: "Questions"
}];
var W5qWPj = [{
  type: 0,
  value: "Centrer"
}];
var WY14Zu = [{
  type: 0,
  value: "Présentateur"
}];
var Wb5zY4 = [{
  type: 0,
  value: "Sélectionner un fichier de police"
}];
var WeD4nB = [{
  type: 0,
  value: "Ajouter un fichier vidéo"
}];
var WlNxMj = [{
  type: 0,
  value: "Répéter"
}];
var Wr9olU = [{
  type: 0,
  value: "Typographie"
}];
var X7kRRa = [{
  type: 0,
  value: "Titre"
}];
var X97njD = [{
  type: 0,
  value: "Entrée"
}];
var XKcyqx = [{
  type: 0,
  value: "Taureau"
}];
var XTJGzY = [{
  type: 0,
  value: "Galerie (fil) avec légendes"
}];
var Xb6r3F = [{
  type: 0,
  value: "Annuler"
}];
var XhgKcw = [{
  type: 0,
  value: "Déplacez la carte pour positionner"
}];
var Xr1v8l = [{
  type: 0,
  value: "points accumulés"
}];
var Y7bs1v = [{
  type: 0,
  value: "Description"
}];
var YD9M2p = [{
  type: 0,
  value: "Surtitre"
}];
var YJZtWR = [{
  type: 0,
  value: "Description"
}];
var YWcp4v = [{
  type: 0,
  value: "Point rempli"
}];
var YwySSO = [{
  type: 0,
  value: "Vertical"
}];
var YyPYHk = [{
  type: 0,
  value: "Scorpion"
}];
var YyYrXp = [{
  type: 0,
  value: "Chargement"
}];
var Z27IP6 = [{
  type: 0,
  value: "Carte"
}];
var Z4f5qh = [{
  type: 0,
  value: "Boutons"
}];
var Z5jrDS = [{
  type: 0,
  value: "Interlettrage"
}];
var ZCe0r4 = [{
  type: 0,
  value: "Description"
}];
var ZLDmja = [{
  type: 0,
  value: "Envoyer"
}];
var Zbu5Uk = [{
  type: 0,
  value: "Libellé"
}];
var ZeosMy = [{
  type: 0,
  value: "21 mars au 19 avr"
}];
var ZiWlL6 = [{
  type: 0,
  value: "Questions"
}];
var ZxgNge = [{
  type: 0,
  value: "Ajouter un élement"
}];
var aarOkd = [{
  type: 0,
  value: "Couleur"
}];
var ahSpiH = [{
  type: 0,
  value: "Lecture"
}];
var al5xjv = [{
  type: 0,
  value: "Polices par défaut"
}];
var amEvH1 = [{
  type: 0,
  value: "Ajustement"
}];
var aovRFH = [{
  type: 0,
  value: "Nom du fichier"
}];
var ap68Fp = [{
  type: 0,
  value: "Signes"
}];
var bLYuuN = [{
  type: 0,
  value: "Vous êtes sur l’écran "
}, {
  type: 1,
  value: "current"
}, {
  type: 0,
  value: " de "
}, {
  type: 1,
  value: "total"
}, {
  type: 0,
  value: "."
}];
var bMdONM = [{
  type: 0,
  value: "21 juin au 22 juil"
}];
var bQsPrs = [{
  type: 0,
  value: "Si ce champ est laissé vide, l'URL de ce Micromag sera utilisée."
}];
var bhEaUt = [{
  type: 0,
  value: "Audio"
}];
var bmO4Ss = [{
  type: 0,
  value: "Titre de l’entrée"
}];
var bv3rRe = [{
  type: 0,
  value: "Bouton"
}];
var c7rrcG = [{
  type: 0,
  value: "Avec ligne anmée"
}];
var cDj1mZ = [{
  type: 0,
  value: "Arrière-plan"
}];
var cGItoy = [{
  type: 0,
  value: "Liste"
}];
var ceaRdq = [{
  type: 0,
  value: "Signe astrologique"
}];
var crLqJd = [{
  type: 0,
  value: "Sans pourcentage"
}];
var cuKSQz = [{
  type: 0,
  value: "Chapeau"
}];
var d3va12 = [{
  type: 0,
  value: "SMS"
}];
var d60tSn = [{
  type: 0,
  value: "Sous-titre"
}];
var dCG1T1 = [{
  type: 0,
  value: "Vidéo d'arrière-plan"
}];
var dFMzBu = [{
  type: 0,
  value: "Aucune image"
}];
var dIvwcD = [{
  type: 0,
  value: "Fermer"
}];
var dPYwJG = [{
  type: 0,
  value: "Carte"
}];
var dSfmnf = [{
  type: 0,
  value: "SMS"
}];
var dVcog7 = [{
  type: 0,
  value: "Titre"
}];
var dkBBRa = [{
  type: 0,
  value: "Ajustement de l’image"
}];
var dqnkQk = [{
  type: 0,
  value: "Légende"
}];
var dxAumJ = [{
  type: 0,
  value: "Poissons"
}];
var e4UTx9 = [{
  type: 0,
  value: "Résultats"
}];
var eBFxNl = [{
  type: 0,
  value: "Action"
}];
var eDMxHS = [{
  type: 0,
  value: "Graisse"
}];
var eNdbJF = [{
  type: 0,
  value: "Délai d'apparition de la bulle (en secondes)"
}];
var eYHEYe = [{
  type: 0,
  value: "Carte"
}];
var ebsPd4 = [{
  type: 0,
  value: "Image"
}];
var eiaIIB = [{
  type: 0,
  value: "Ce Micromag"
}];
var enFs4g = [{
  type: 0,
  value: "Avancé"
}];
var eoW0tZ = [{
  type: 0,
  value: "Durée"
}];
var f1XHNG = [{
  type: 0,
  value: "Bouton"
}];
var f5Yipd = [{
  type: 0,
  value: "Boîte"
}];
var fBii8l = [{
  type: 0,
  value: "Verseau"
}];
var fIawTr = [{
  type: 0,
  value: "Texte"
}];
var fLdjGi = [{
  type: 0,
  value: "Mot de la semaine"
}];
var fOYYk7 = [{
  type: 0,
  value: "Aligner les éléments"
}];
var fVqgfl = [{
  type: 0,
  value: "[sans titre]"
}];
var fbUW2U = [{
  type: 0,
  value: "Éléments"
}];
var fbiNiR = [{
  type: 0,
  value: "Choisir une taille..."
}];
var fusnxf = [{
  type: 0,
  value: "Carré"
}];
var g2CRt5 = [{
  type: 0,
  value: "Taille"
}];
var g4nybp = [{
  type: 0,
  value: "Bas de l'écran"
}];
var g6b9Lg = [{
  type: 0,
  value: "Contribution"
}];
var gRxcTc = [{
  type: 0,
  value: "Supprimer l’écran"
}];
var hUUIQt = [{
  type: 0,
  value: "Vidéo d'arrière-plan en sourdine"
}];
var hVE7TA = [{
  type: 0,
  value: "Question"
}];
var hoDz0O = [{
  type: 0,
  value: "Description"
}];
var hpiKce = [{
  type: 0,
  value: "Supprimer l’écran"
}];
var hqOIl4 = [{
  type: 0,
  value: "Photo de profil"
}];
var hvxkzE = [{
  type: 0,
  value: "LinkedIn"
}];
var hzvEim = [{
  type: 0,
  value: "Libellé du présentateur"
}];
var i6bmbD = [{
  type: 0,
  value: "Bouton"
}];
var iHV3W3 = [{
  type: 0,
  value: "Aucune entrée"
}];
var iJ61ZT = [{
  type: 0,
  value: "Durée d'écriture (en secondes)"
}];
var iL9RLu = [{
  type: 0,
  value: "Collaborateur"
}];
var iQ5Uf7 = [{
  type: 0,
  value: "Rétroaction par défaut"
}];
var iipV5Q = [{
  type: 0,
  value: "Type"
}];
var irG6mX = [{
  type: 0,
  value: "Distance"
}];
var j00v1T = [{
  type: 0,
  value: "Vrai"
}];
var jEK6B8 = [{
  type: 0,
  value: "Par"
}];
var jWAJW4 = [{
  type: 0,
  value: "Points"
}];
var jaFXki = [{
  type: 0,
  value: "Galerie"
}];
var jnww6n = [{
  type: 0,
  value: "Sélectionner une image"
}];
var k81FRn = [{
  type: 0,
  value: "Style du texte"
}];
var kBz8vF = [{
  type: 0,
  value: "Nom"
}];
var l5uLMd = [{
  type: 0,
  value: "Boutons"
}];
var li7ADr = [{
  type: 0,
  value: "Résultat"
}];
var liyV7Y = [{
  type: 0,
  value: "Taille"
}];
var mOSkbf = [{
  type: 0,
  value: "Utilisation"
}];
var mTqcmA = [{
  type: 0,
  value: "Pause"
}];
var mXeSkg = [{
  type: 0,
  value: "Lien"
}];
var mgjMWG = [{
  type: 0,
  value: "colonnes"
}];
var muYwrB = [{
  type: 0,
  value: "Images"
}];
var mv37oK = [{
  type: 0,
  value: "Dimension"
}];
var n2teag = [{
  type: 0,
  value: "Ajouter une réponse"
}];
var n8zmLY = [{
  type: 0,
  value: "Aller au prochain écran à la fin"
}];
var n9LoBJ = [{
  type: 0,
  value: "Haut"
}];
var nJgzwC = [{
  type: 0,
  value: "Urbania Article"
}];
var nXVNeg = [{
  type: 0,
  value: "Nom"
}];
var nc8LF0 = [{
  type: 0,
  value: "Métadonnées"
}];
var nno1Pq = [{
  type: 0,
  value: "Style du bouton"
}];
var oAtOlP = [{
  type: 0,
  value: "En-tête"
}];
var oCBQKV = [{
  type: 0,
  value: "Texte avec titre"
}];
var oLtEu6 = [{
  type: 0,
  value: "Vidéo 360"
}];
var oPjl8f = [{
  type: 0,
  value: "Urbania"
}];
var opcGwP = [{
  type: 0,
  value: "Ajouter un interlocuteur"
}];
var ouMwWq = [{
  type: 0,
  value: "Article"
}];
var p1pghO = [{
  type: 0,
  value: "Style de boîte"
}];
var p5RHzq = [{
  type: 0,
  value: "Style du texte des boutons"
}];
var p6n6vY = [{
  type: 0,
  value: "Pas de réponse"
}];
var p85qJD = [{
  type: 0,
  value: "Légende"
}];
var pE7UhY = [{
  type: 0,
  value: "Article"
}];
var pJgYyE = [{
  type: 0,
  value: "Lecture automatique"
}];
var pRzSQ7 = [{
  type: 0,
  value: "Surtitre"
}];
var pfvDzR = [{
  type: 0,
  value: "Ajouté par"
}];
var ppq6CK = [{
  type: 0,
  value: "Type"
}];
var ptJkUl = [{
  type: 0,
  value: "Droite"
}];
var qIw1nW = [{
  type: 0,
  value: "Enregistrer"
}];
var qKQCxc = [{
  type: 0,
  value: "Ajouter un marqueur"
}];
var qhjeuO = [{
  type: 0,
  value: "Marges"
}];
var qroLmS = [{
  type: 0,
  value: "Marqueur"
}];
var rAkTvt = [{
  type: 0,
  value: "22 déc au 20 jan"
}];
var rBPIgw = [{
  type: 0,
  value: "Conversation"
}];
var rKuiKj = [{
  type: 0,
  value: "Copier le lien"
}];
var raUY02 = [{
  type: 0,
  value: "20 avr au 20 mai"
}];
var rdFCsN = [{
  type: 0,
  value: "Aucun marqueur"
}];
var rhuDxI = [{
  type: 0,
  value: "Haut de l'écran"
}];
var ro6yHS = [{
  type: 0,
  value: "Carte avec images"
}];
var rqbRV2 = [{
  type: 0,
  value: "Désolé, ce média n'a pas pu être supprimé."
}];
var ru3tjH = [{
  type: 0,
  value: "Mauvaise réponse"
}];
var rzXCu2 = [{
  type: 0,
  value: "Style du libellé"
}];
var rzdds2 = [{
  type: 0,
  value: "Interlocuteur"
}];
var sESmah = [{
  type: 0,
  value: "Entrées"
}];
var sSahY1 = [{
  type: 0,
  value: "Pop-up"
}];
var sUP5BO = [{
  type: 0,
  value: "Urbania Recommandation"
}];
var sUR1xV = [{
  type: 0,
  value: "Auteur"
}];
var sXfFFw = [{
  type: 0,
  value: "Entrer"
}];
var t2cFdl = [{
  type: 0,
  value: "Filtres actifs"
}];
var tAYwqp = [{
  type: 0,
  value: "Ajouter une diapositive"
}];
var tYGev7 = [{
  type: 0,
  value: "Taille de la police"
}];
var tmfbUn = [{
  type: 0,
  value: "Inutilisé"
}];
var tvl2Zc = [{
  type: 0,
  value: "Vidéo"
}];
var twTaAZ = [{
  type: 0,
  value: "Forme du point"
}];
var u3ok54 = [{
  type: 0,
  value: "Position"
}];
var uAKPQ9 = [{
  type: 0,
  value: "Envoyer"
}];
var uDHTZn = [{
  type: 0,
  value: "Description des résultats"
}];
var uJ9eBc = [{
  type: 0,
  value: "Image"
}];
var uKJRh2 = [{
  type: 0,
  value: "Titre"
}];
var uNpHnA = [{
  type: 0,
  value: "Couleur du point"
}];
var uSpItE = [{
  type: 0,
  value: "Ajouter des étiquettes"
}];
var uaL28k = [{
  type: 0,
  value: "Suggestion de partage"
}];
var udLCuY = [{
  type: 0,
  value: "Ombre"
}];
var uiTxd7 = [{
  type: 0,
  value: "Résultats"
}];
var uoF5Pv = [{
  type: 0,
  value: "Contenu"
}];
var upzOTm = [{
  type: 0,
  value: "Crédits"
}];
var ur6G0U = [{
  type: 0,
  value: "En voir plus"
}];
var uwcXzb = [{
  type: 0,
  value: "Image"
}];
var v1r3AA = [{
  type: 0,
  value: "Couleur de la barre de progression"
}];
var v4Qtl9 = [{
  type: 0,
  value: "Aujourd'hui"
}];
var v9bqYj = [{
  type: 0,
  value: "Aller à l'écran suivant"
}];
var vERejo = [{
  type: 0,
  value: "Vidéo"
}];
var vRzzo6 = [{
  type: 0,
  value: "Zoom"
}];
var vZrFq6 = [{
  type: 0,
  value: "Titre avec sous-titre et crédits"
}];
var vdWMTA = [{
  type: 0,
  value: "Surtitre"
}];
var vmrJ8U = [{
  type: 0,
  value: "(écran en cours)"
}];
var vxEtY1 = [{
  type: 0,
  value: "Image d’arrière-plan"
}];
var vzg8Es = [{
  type: 0,
  value: "Désactiver le son"
}];
var wkysUu = [{
  type: 0,
  value: "Écrans"
}];
var wx5PI0 = [{
  type: 0,
  value: "Titre"
}];
var xAzv6g = [{
  type: 0,
  value: "Toutes les sources"
}];
var xCj1gI = [{
  type: 0,
  value: "Ajouter un message"
}];
var xFlbR7 = [{
  type: 0,
  value: "Lien copié!"
}];
var xKG76H = [{
  type: 0,
  value: "Coins arrondis"
}];
var xL0GD2 = [{
  type: 0,
  value: "23 août au 22 sept"
}];
var xTJlyi = [{
  type: 0,
  value: "Horizontal"
}];
var xYqGzM = [{
  type: 0,
  value: "Auteur"
}];
var xj0o1v = [{
  type: 0,
  value: "Grille"
}];
var xmp9nw = [{
  type: 0,
  value: "Espacement"
}];
var xsipID = [{
  type: 0,
  value: "Image"
}];
var xuEZXD = [{
  type: 0,
  value: "Modifier"
}];
var xuPbeq = [{
  type: 0,
  value: "Commencer à l'écran en cours"
}];
var y7xsPe = [{
  type: 0,
  value: "Paramètres avancés"
}];
var yA4B6h = [{
  type: 0,
  value: "Image de rétroaction"
}];
var yCXMzz = [{
  type: 0,
  value: "Fermer"
}];
var yCj5uv = [{
  type: 0,
  value: "23 nov au 21 déc"
}];
var yEG9zh = [{
  type: 0,
  value: "Date"
}];
var yMpGIc = [{
  type: 0,
  value: "Article"
}];
var z2I2bJ = [{
  type: 0,
  value: "Surtitre"
}];
var z4CiV1 = [{
  type: 0,
  value: "Texte"
}];
var z9nSIG = [{
  type: 0,
  value: "Style de texte du contenu"
}];
var zDH24s = [{
  type: 0,
  value: "Latitude"
}];
var zDdDqI = [{
  type: 0,
  value: "Urbania Insolite"
}];
var zGIcdn = [{
  type: 0,
  value: "Présentateurs"
}];
var zLxBdl = [{
  type: 0,
  value: "Lieu"
}];
var zW7IVm = [{
  type: 0,
  value: "Quiz"
}];
var zl6zsZ = [{
  type: 0,
  value: "Chapeau"
}];
var zrK6ak = [{
  type: 0,
  value: "Style de texte de l'en-tête"
}];
var zueWSA = [{
  type: 0,
  value: "Audio joint"
}];
var messages = {
  "+9akmg": [{
    type: 0,
    value: "Audio et vidéo"
  }],
  "+AEVbJ": [{
    type: 0,
    value: "Titre"
  }],
  "+FHxPO": [{
    type: 0,
    value: "Titre questions"
  }],
  "+LvOvJ": [{
    type: 0,
    value: "Marqueurs"
  }],
  "+MPZRu": [{
    type: 0,
    value: "Arrière-plan"
  }],
  "+Ok+7S": [{
    type: 0,
    value: "Réponse"
  }],
  "+SlKOi": [{
    type: 0,
    value: "Style de message publié"
  }],
  "+TPjd4": [{
    type: 0,
    value: "Présenté par"
  }],
  "+nhSvj": [{
    type: 0,
    value: "Pas d'interlocuteur..."
  }],
  "+uInZz": [{
    type: 0,
    value: "Cercle"
  }],
  "+vzDdb": [{
    type: 0,
    value: "Le mot de la semaine"
  }],
  "/0hgRs": [{
    type: 0,
    value: "Modifier le texte"
  }],
  "/62oe4": [{
    type: 0,
    value: "Mes fichiers"
  }],
  "/6zaOP": [{
    type: 0,
    value: "Délai de transition (en secondes)"
  }],
  "/KQ87r": [{
    type: 0,
    value: "Supprimer ce média"
  }],
  "/MsgWe": [{
    type: 0,
    value: "Date"
  }],
  "/OM5UY": [{
    type: 0,
    value: "Mots-clés"
  }],
  "/PJA/1": [{
    type: 0,
    value: "Bélier"
  }],
  "/T/UDH": [{
    type: 0,
    value: "Tout effacer"
  }],
  "/W31TQ": [{
    type: 0,
    value: "Navigateur intégré"
  }],
  "/YQ+xP": [{
    type: 0,
    value: "Image 360"
  }],
  "/ca7BX": [{
    type: 0,
    value: "Types"
  }],
  "/hupzO": [{
    type: 0,
    value: "Crédits"
  }],
  "0GT0SI": [{
    type: 0,
    value: "Annuler"
  }],
  "0GzLBc": [{
    type: 0,
    value: "Message"
  }],
  "0R+nB5": [{
    type: 0,
    value: "URL personnalisée"
  }],
  "0acGK7": [{
    type: 0,
    value: "Cancer"
  }],
  "142Fjj": [{
    type: 0,
    value: "21 mai au 20 juin"
  }],
  "15GBmG": [{
    type: 0,
    value: "Tout"
  }],
  "169xnt": [{
    type: 0,
    value: "Audio"
  }],
  "17BMn2": [{
    type: 0,
    value: "Classement"
  }],
  "2/F1Q7": [{
    type: 0,
    value: "#"
  }, {
    type: 1,
    value: "index"
  }],
  "2FD6tj": [{
    type: 0,
    value: "Ce média est utilisé par les documents suivants:"
  }],
  "2J05S0": [{
    type: 0,
    value: "Images"
  }],
  "2LbLWQ": [{
    type: 0,
    value: "Aucun"
  }],
  "2ZOPe+": [{
    type: 0,
    value: "Titre"
  }],
  "2c1WFV": [{
    type: 0,
    value: "Titre"
  }],
  "2pO2Cj": [{
    type: 0,
    value: "Url"
  }],
  "2uFkwE": [{
    type: 0,
    value: "Durées personnalisées"
  }],
  "31zuCS": [{
    type: 0,
    value: "Hauteur de ligne"
  }],
  "33UbSd": [{
    type: 0,
    value: "Ligne du temps avec images"
  }],
  "3Ap0C1": [{
    type: 0,
    value: "Ajouter un média"
  }],
  "3B9cb3": [{
    type: 0,
    value: "Whatsapp"
  }],
  "3E57H7": [{
    type: 0,
    value: "Aucun marqueur"
  }],
  "3LEBIA": [{
    type: 0,
    value: "Angle"
  }],
  "3OS3Ms": [{
    type: 0,
    value: "Légende"
  }],
  "3ext9Q": [{
    type: 0,
    value: "Vidéo"
  }],
  "3ifj0j": [{
    type: 0,
    value: "Entrées"
  }],
  "3na7F8": [{
    type: 0,
    value: "Maintenant"
  }],
  "3q9GPv": [{
    type: 0,
    value: "Citation"
  }],
  "3wiL2y": [{
    type: 0,
    value: "Aucune image"
  }],
  "4E2gbX": [{
    type: 0,
    value: "Texte"
  }],
  "4H2n5r": [{
    type: 0,
    value: "Sous-titres"
  }],
  "4POR3B": [{
    type: 0,
    value: "Afficher l’écran"
  }],
  "4R/bdr": [{
    type: 0,
    value: "Message"
  }],
  "4YiKNK": [{
    type: 0,
    value: "Sélectionner une couleur"
  }],
  "4b5gym": [{
    type: 0,
    value: "Titre de l'écran"
  }],
  "4bHvRS": [{
    type: 0,
    value: "Galerie (fil)"
  }],
  "4fHMVj": [{
    type: 0,
    value: "Mots-clés"
  }],
  "4g35M0": [{
    type: 0,
    value: "Gémeaux"
  }],
  "4grcMU": [{
    type: 0,
    value: "Catégorie"
  }],
  "4iBXj2": [{
    type: 0,
    value: "Disposition"
  }],
  "4js1kW": [{
    type: 0,
    value: "Options de partage"
  }],
  "4kSwvn": [{
    type: 0,
    value: "Vignette"
  }],
  "507VAi": [{
    type: 0,
    value: "Description"
  }],
  "57hjHa": [{
    type: 0,
    value: "Image de rétroaction"
  }],
  "59f2bg": [{
    type: 0,
    value: "Images"
  }],
  "5mk1b+": [{
    type: 0,
    value: "Partager"
  }],
  "5uH4x7": [{
    type: 0,
    value: "Envoyer"
  }],
  "64JlRq": [{
    type: 0,
    value: "Partage"
  }],
  "650XRF": [{
    type: 0,
    value: "Sondage"
  }],
  "65rc70": [{
    type: 0,
    value: "Modifier le style"
  }],
  "6DV50M": [{
    type: 0,
    value: "Mode"
  }],
  "6MxaVf": [{
    type: 0,
    value: "Style"
  }],
  "6Q4tcn": [{
    type: 0,
    value: "Style des résultats"
  }],
  "6W4St0": [{
    type: 0,
    value: "Ajouter un fichier audio"
  }],
  "6ak5YN": [{
    type: 0,
    value: "Côté"
  }],
  "6bd963": [{
    type: 0,
    value: "Vierge"
  }],
  "6iR9Mt": [{
    type: 0,
    value: "Titre"
  }],
  "6jX5Tb": [{
    type: 0,
    value: "Auteurs"
  }],
  "6mX2ya": [{
    type: 0,
    value: "Images"
  }],
  "6tIigB": [{
    type: 0,
    value: "Légende"
  }],
  "73hxYw": [{
    type: 0,
    value: "Auteur"
  }],
  "75nZbY": [{
    type: 0,
    value: "Clavier"
  }],
  "7ZzlUE": [{
    type: 0,
    value: "23 oct au 22 nov"
  }],
  "7mMPO4": [{
    type: 0,
    value: "Sagittaire"
  }],
  "7tw6U2": [{
    type: 0,
    value: "Partager"
  }],
  "7uyslu": [{
    type: 0,
    value: "Description"
  }],
  "82g1F5": [{
    type: 0,
    value: "Intro"
  }],
  "862eE3": [{
    type: 0,
    value: "Bordure"
  }],
  "88/Ge8": [{
    type: 0,
    value: "Citation"
  }],
  "8A8cuq": [{
    type: 0,
    value: "Paramètres"
  }],
  "8TbpT7": [{
    type: 0,
    value: "Enlever"
  }],
  "8oczXQ": [{
    type: 0,
    value: "Ajouter un marqueur"
  }],
  "8sWUOV": [{
    type: 0,
    value: "Ajouter un fichier de polices"
  }],
  "8tANs8": [{
    type: 0,
    value: "Conversation"
  }],
  "9AP246": [{
    type: 0,
    value: "Date"
  }],
  "9DhYaZ": [{
    type: 0,
    value: "Ordre croissant"
  }],
  "9PfjeE": [{
    type: 0,
    value: "Style du nom"
  }],
  "9ZdD+Q": [{
    type: 0,
    value: "Bibliothèque pour"
  }],
  "9a5s+m": [{
    type: 0,
    value: "Titre avec encadré"
  }],
  "9n9+yP": [{
    type: 0,
    value: "Ajouter une image"
  }],
  "A+a0kL": [{
    type: 0,
    value: "Aucune réponse"
  }],
  "A/Vr8P": [{
    type: 0,
    value: "Faux"
  }],
  A7ncT3: A7ncT3,
  AA8TV9: AA8TV9,
  ACSasN: ACSasN,
  ACkeH6: ACkeH6,
  AHvHaY: AHvHaY,
  AQ8Aig: AQ8Aig,
  AV6gfh: AV6gfh,
  "B1MeY+": [{
    type: 0,
    value: "Sélectionner une image"
  }],
  B5C18D: B5C18D,
  BAfC6s: BAfC6s,
  BSTWf8: BSTWf8,
  BgrRxZ: BgrRxZ,
  BnRW4y: BnRW4y,
  BpZoQZ: BpZoQZ,
  BwYZbB: BwYZbB,
  CJmQeh: CJmQeh,
  CWnXWp: CWnXWp,
  CrzYgw: CrzYgw,
  D21uVQ: D21uVQ,
  D29KoV: D29KoV,
  D7LIZQ: D7LIZQ,
  D7kxD3: D7kxD3,
  DU1qdc: DU1qdc,
  DWEzCv: DWEzCv,
  "DYjRd/": [{
    type: 0,
    value: "Désolé, ce média n'a pas pu être sauvegardé."
  }],
  EDFyUp: EDFyUp,
  EEUc6n: EEUc6n,
  EQdIAR: EQdIAR,
  ET527E: ET527E,
  EcZYpr: EcZYpr,
  EoVdMy: EoVdMy,
  Evl2dG: Evl2dG,
  "F/gl4b": [{
    type: 0,
    value: "Menu"
  }],
  F0QDfY: F0QDfY,
  "F2SD/0": [{
    type: 0,
    value: "Boucle"
  }],
  F59wsl: F59wsl,
  FKOWH0: FKOWH0,
  FOmgqv: FOmgqv,
  "FYm4w+": [{
    type: 0,
    value: "Pop-ups"
  }],
  FjuRaw: FjuRaw,
  "G/ITGY": [{
    type: 0,
    value: "Votre nom"
  }],
  G1Gyjn: G1Gyjn,
  GMCLhn: GMCLhn,
  GPqjnH: GPqjnH,
  GRVidW: GRVidW,
  GzoKNb: GzoKNb,
  H1YcaV: H1YcaV,
  "HTd98/": [{
    type: 0,
    value: "Pas de message"
  }],
  HWpflq: HWpflq,
  HseFdk: HseFdk,
  HwqzVR: HwqzVR,
  I1hyZY: I1hyZY,
  I2bIHm: I2bIHm,
  "I5+AHN": [{
    type: 0,
    value: "Catégorie"
  }],
  IBjY5r: IBjY5r,
  ICXTfR: ICXTfR,
  "IE7U/Q": [{
    type: 0,
    value: "Titre"
  }],
  J9e9Qb: J9e9Qb,
  JAguka: JAguka,
  JC9Qlf: JC9Qlf,
  JDPMlG: JDPMlG,
  JRZoe6: JRZoe6,
  JoWKee: JoWKee,
  JoyIgA: JoyIgA,
  JzSBzL: JzSBzL,
  K1BxIr: K1BxIr,
  KB7N5E: KB7N5E,
  KCDOHI: KCDOHI,
  KHWeV7: KHWeV7,
  KK5teQ: KK5teQ,
  KdAKt7: KdAKt7,
  KuzZbb: KuzZbb,
  KvBdrU: KvBdrU,
  LFziCV: LFziCV,
  LI0Gz4: LI0Gz4,
  LOknw0: LOknw0,
  LkVfwW: LkVfwW,
  "LrRW+9": [{
    type: 0,
    value: "Ajouter un bouton"
  }],
  Lrwi2G: Lrwi2G,
  "Lz2+Ws": [{
    type: 0,
    value: "Rétroaction de la réponse"
  }],
  "M/FGRs": [{
    type: 0,
    value: "Balance"
  }],
  MBgLeH: MBgLeH,
  MYZwSA: MYZwSA,
  MhGUaY: MhGUaY,
  MmJQ7o: MmJQ7o,
  N25iDO: N25iDO,
  N7Kj8z: N7Kj8z,
  NVUpOG: NVUpOG,
  NmCfTO: NmCfTO,
  NumcrW: NumcrW,
  "O2JVA+": [{
    type: 0,
    value: "Gauche"
  }],
  "OJi+eg": [{
    type: 0,
    value: "Libellé"
  }],
  "OPxJx/": [{
    type: 0,
    value: "Disposition"
  }],
  OSl7A6: OSl7A6,
  OdcEna: OdcEna,
  OkNUmk: OkNUmk,
  Op1ZIp: Op1ZIp,
  P1dwGU: P1dwGU,
  P9A8cx: P9A8cx,
  PFNMAQ: PFNMAQ,
  PKCv5M: PKCv5M,
  "PNMMo/": [{
    type: 0,
    value: "Audios"
  }],
  PyxZY2: PyxZY2,
  QBaiO0: QBaiO0,
  QBlqW9: QBlqW9,
  QSmRdP: QSmRdP,
  Qanvis: Qanvis,
  Qe03Xz: Qe03Xz,
  QfpTKK: QfpTKK,
  QjbLZ9: QjbLZ9,
  Qw8cb5: Qw8cb5,
  R9DB4a: R9DB4a,
  RHMS2f: RHMS2f,
  "RK/QEY": [{
    type: 0,
    value: "Activer le son"
  }],
  RcLsua: RcLsua,
  Rl7C1A: Rl7C1A,
  RucIeL: RucIeL,
  "S+WiGT": [{
    type: 0,
    value: "Texte du pourcentage"
  }],
  "S/mavZ": [{
    type: 0,
    value: "Texte et images"
  }],
  "S1F/re": [{
    type: 0,
    value: "Colonnes"
  }],
  S9YpbV: S9YpbV,
  SyMSDa: SyMSDa,
  T0pi1u: T0pi1u,
  T9NZPQ: T9NZPQ,
  THKV4v: THKV4v,
  "TTPc+y": [{
    type: 0,
    value: "Utiliser des touches carrées"
  }],
  TZUu3s: TZUu3s,
  "Tol+/U": [{
    type: 0,
    value: "Effacer"
  }],
  Tt4jN1: Tt4jN1,
  UBXIYP: UBXIYP,
  UG3SXh: UG3SXh,
  UUv8FR: UUv8FR,
  UdrdRF: UdrdRF,
  UlZIP8: UlZIP8,
  UtcYEP: UtcYEP,
  "V+G2s+": [{
    type: 0,
    value: "Ajouter une image"
  }],
  VDu2FA: VDu2FA,
  VMd1oG: VMd1oG,
  W5qWPj: W5qWPj,
  WY14Zu: WY14Zu,
  Wb5zY4: Wb5zY4,
  WeD4nB: WeD4nB,
  WlNxMj: WlNxMj,
  Wr9olU: Wr9olU,
  X7kRRa: X7kRRa,
  X97njD: X97njD,
  "XJ2Xc+": [{
    type: 0,
    value: "Réponse"
  }],
  XKcyqx: XKcyqx,
  "XR5/Wk": [{
    type: 0,
    value: "Éditer"
  }],
  XTJGzY: XTJGzY,
  Xb6r3F: Xb6r3F,
  XhgKcw: XhgKcw,
  Xr1v8l: Xr1v8l,
  Y7bs1v: Y7bs1v,
  YD9M2p: YD9M2p,
  YJZtWR: YJZtWR,
  YWcp4v: YWcp4v,
  YwySSO: YwySSO,
  YyPYHk: YyPYHk,
  YyYrXp: YyYrXp,
  Z27IP6: Z27IP6,
  Z4f5qh: Z4f5qh,
  Z5jrDS: Z5jrDS,
  ZCe0r4: ZCe0r4,
  ZLDmja: ZLDmja,
  Zbu5Uk: Zbu5Uk,
  ZeosMy: ZeosMy,
  ZiWlL6: ZiWlL6,
  ZxgNge: ZxgNge,
  aarOkd: aarOkd,
  ahSpiH: ahSpiH,
  al5xjv: al5xjv,
  amEvH1: amEvH1,
  aovRFH: aovRFH,
  ap68Fp: ap68Fp,
  bLYuuN: bLYuuN,
  bMdONM: bMdONM,
  bQsPrs: bQsPrs,
  bhEaUt: bhEaUt,
  bmO4Ss: bmO4Ss,
  bv3rRe: bv3rRe,
  c7rrcG: c7rrcG,
  "c9VwT/": [{
    type: 0,
    value: "Détails techniques"
  }],
  cDj1mZ: cDj1mZ,
  cGItoy: cGItoy,
  ceaRdq: ceaRdq,
  crLqJd: crLqJd,
  cuKSQz: cuKSQz,
  "d/01YO": [{
    type: 0,
    value: "Partagez ce micromag!"
  }],
  d3va12: d3va12,
  d60tSn: d60tSn,
  dCG1T1: dCG1T1,
  dFMzBu: dFMzBu,
  dIvwcD: dIvwcD,
  dPYwJG: dPYwJG,
  dSfmnf: dSfmnf,
  dVcog7: dVcog7,
  "dj/p/q": [{
    type: 0,
    value: "Fermer"
  }],
  dkBBRa: dkBBRa,
  dqnkQk: dqnkQk,
  dxAumJ: dxAumJ,
  "e1I+KU": [{
    type: 0,
    value: "Question"
  }],
  e4UTx9: e4UTx9,
  "e6+aGf": [{
    type: 0,
    value: "Sélectionner un média"
  }],
  eBFxNl: eBFxNl,
  eDMxHS: eDMxHS,
  eNdbJF: eNdbJF,
  "eWIM/8": [{
    type: 0,
    value: "Image avec titre et texte"
  }],
  eYHEYe: eYHEYe,
  ebsPd4: ebsPd4,
  eiaIIB: eiaIIB,
  enFs4g: enFs4g,
  eoW0tZ: eoW0tZ,
  f1XHNG: f1XHNG,
  f5Yipd: f5Yipd,
  "f68O+0": [{
    type: 0,
    value: "Messages"
  }],
  fBii8l: fBii8l,
  fIawTr: fIawTr,
  fLdjGi: fLdjGi,
  fOYYk7: fOYYk7,
  fVqgfl: fVqgfl,
  fbUW2U: fbUW2U,
  fbiNiR: fbiNiR,
  fusnxf: fusnxf,
  g2CRt5: g2CRt5,
  g4nybp: g4nybp,
  g6b9Lg: g6b9Lg,
  gRxcTc: gRxcTc,
  "gwPu/I": [{
    type: 0,
    value: "Texte des boutons"
  }],
  hUUIQt: hUUIQt,
  hVE7TA: hVE7TA,
  hoDz0O: hoDz0O,
  hpiKce: hpiKce,
  hqOIl4: hqOIl4,
  hvxkzE: hvxkzE,
  hzvEim: hzvEim,
  "i+3ZrF": [{
    type: 0,
    value: "Sélectionner une police"
  }],
  i6bmbD: i6bmbD,
  "iCf/MP": [{
    type: 0,
    value: "Modifier"
  }],
  iHV3W3: iHV3W3,
  iJ61ZT: iJ61ZT,
  iL9RLu: iL9RLu,
  iQ5Uf7: iQ5Uf7,
  iipV5Q: iipV5Q,
  irG6mX: irG6mX,
  j00v1T: j00v1T,
  jEK6B8: jEK6B8,
  jWAJW4: jWAJW4,
  jaFXki: jaFXki,
  "jf+4Hq": [{
    type: 0,
    value: "Écrans"
  }],
  jnww6n: jnww6n,
  "k+coTi": [{
    type: 0,
    value: "Image"
  }],
  k81FRn: k81FRn,
  kBz8vF: kBz8vF,
  "kf/5Tw": [{
    type: 0,
    value: "Droite"
  }],
  "l/Y6or": [{
    type: 0,
    value: "Ajouter une entrée"
  }],
  l5uLMd: l5uLMd,
  "lGh/NP": [{
    type: 0,
    value: "Ajouter une réponse"
  }],
  li7ADr: li7ADr,
  liyV7Y: liyV7Y,
  mOSkbf: mOSkbf,
  mTqcmA: mTqcmA,
  mXeSkg: mXeSkg,
  "menus.pagination.next": [{
    type: 0,
    value: "suivant"
  }],
  "menus.pagination.previous": [{
    type: 0,
    value: "Précédent"
  }],
  mgjMWG: mgjMWG,
  "mlucL+": [{
    type: 0,
    value: "Twitter"
  }],
  "muPX/j": [{
    type: 0,
    value: "Interlocuteur"
  }],
  muYwrB: muYwrB,
  mv37oK: mv37oK,
  "n/SxMs": [{
    type: 0,
    value: "Chercher dans les médias"
  }],
  n2teag: n2teag,
  n8zmLY: n8zmLY,
  n9LoBJ: n9LoBJ,
  nJgzwC: nJgzwC,
  nXVNeg: nXVNeg,
  nc8LF0: nc8LF0,
  nno1Pq: nno1Pq,
  "o3R+FM": [{
    type: 0,
    value: "Choisir un fichier de sous-titres"
  }],
  oAtOlP: oAtOlP,
  oCBQKV: oCBQKV,
  oLtEu6: oLtEu6,
  oPjl8f: oPjl8f,
  opcGwP: opcGwP,
  ouMwWq: ouMwWq,
  p1pghO: p1pghO,
  p5RHzq: p5RHzq,
  p6n6vY: p6n6vY,
  "p6q/+/": [{
    type: 0,
    value: "Supprimer l’écran"
  }],
  p85qJD: p85qJD,
  pE7UhY: pE7UhY,
  pJgYyE: pJgYyE,
  pRzSQ7: pRzSQ7,
  pfvDzR: pfvDzR,
  ppq6CK: ppq6CK,
  ptJkUl: ptJkUl,
  "q/tLk0": [{
    type: 0,
    value: "Êtes-vous sûr de vouloir supprimer cet écran?"
  }],
  qIw1nW: qIw1nW,
  qKQCxc: qKQCxc,
  qhjeuO: qhjeuO,
  "qjL/eA": [{
    type: 0,
    value: "Barre"
  }],
  qroLmS: qroLmS,
  "r+bcpa": [{
    type: 0,
    value: "Facebook"
  }],
  rAkTvt: rAkTvt,
  rBPIgw: rBPIgw,
  rKuiKj: rKuiKj,
  raUY02: raUY02,
  rdFCsN: rdFCsN,
  rhuDxI: rhuDxI,
  ro6yHS: ro6yHS,
  rqbRV2: rqbRV2,
  ru3tjH: ru3tjH,
  rzXCu2: rzXCu2,
  rzdds2: rzdds2,
  sESmah: sESmah,
  sSahY1: sSahY1,
  sUP5BO: sUP5BO,
  sUR1xV: sUR1xV,
  sXfFFw: sXfFFw,
  "t+L1J/": [{
    type: 0,
    value: "Pas d’image"
  }],
  t2cFdl: t2cFdl,
  tAYwqp: tAYwqp,
  tYGev7: tYGev7,
  tmfbUn: tmfbUn,
  tvl2Zc: tvl2Zc,
  twTaAZ: twTaAZ,
  u3ok54: u3ok54,
  uAKPQ9: uAKPQ9,
  uDHTZn: uDHTZn,
  uJ9eBc: uJ9eBc,
  uKJRh2: uKJRh2,
  uNpHnA: uNpHnA,
  uSpItE: uSpItE,
  uaL28k: uaL28k,
  udLCuY: udLCuY,
  uiTxd7: uiTxd7,
  uoF5Pv: uoF5Pv,
  upzOTm: upzOTm,
  ur6G0U: ur6G0U,
  uwcXzb: uwcXzb,
  v1r3AA: v1r3AA,
  v4Qtl9: v4Qtl9,
  v9bqYj: v9bqYj,
  vERejo: vERejo,
  vRzzo6: vRzzo6,
  "vYunz+": [{
    type: 0,
    value: "Recherches récentes"
  }],
  vZrFq6: vZrFq6,
  vdWMTA: vdWMTA,
  vmrJ8U: vmrJ8U,
  vxEtY1: vxEtY1,
  vzg8Es: vzg8Es,
  "wChc+A": [{
    type: 0,
    value: "Modifier le style"
  }],
  wkysUu: wkysUu,
  "wt1+dM": [{
    type: 0,
    value: "Sélectionner un fichier audio"
  }],
  wx5PI0: wx5PI0,
  "wy2g+x": [{
    type: 0,
    value: "Êtes-vous certain.e de vouloir continuer?"
  }],
  xAzv6g: xAzv6g,
  xCj1gI: xCj1gI,
  xFlbR7: xFlbR7,
  xKG76H: xKG76H,
  xL0GD2: xL0GD2,
  "xT/onn": [{
    type: 0,
    value: "Image"
  }],
  xTJlyi: xTJlyi,
  xYqGzM: xYqGzM,
  xj0o1v: xj0o1v,
  xmp9nw: xmp9nw,
  xsipID: xsipID,
  xuEZXD: xuEZXD,
  xuPbeq: xuPbeq,
  y7xsPe: y7xsPe,
  yA4B6h: yA4B6h,
  yCXMzz: yCXMzz,
  yCj5uv: yCj5uv,
  yEG9zh: yEG9zh,
  yMpGIc: yMpGIc,
  "z/VBX0": [{
    type: 0,
    value: "En savoir plus"
  }],
  z2I2bJ: z2I2bJ,
  z4CiV1: z4CiV1,
  "z4Pr+g": [{
    type: 0,
    value: "Visuel (image ou vidéo)"
  }],
  z9nSIG: z9nSIG,
  zDH24s: zDH24s,
  zDdDqI: zDdDqI,
  zGIcdn: zGIcdn,
  zLxBdl: zLxBdl,
  zW7IVm: zW7IVm,
  "zYH/31": [{
    type: 0,
    value: "Aller à l'écran précédent"
  }],
  "zh2m/S": [{
    type: 0,
    value: "Cherchez une police..."
  }],
  zl6zsZ: zl6zsZ,
  zrK6ak: zrK6ak,
  zueWSA: zueWSA
};

/* eslint-disable */
manager.addLocale('fr', messages);
